import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from "@heroui/react";
import { TableBuilder } from "../../tables/tableBuilder";
import { User } from "@/api/auth/auth.ts";
import { ColumnType } from "../../tables/tableTypes";

export function UserModal({
  isOpen,
  onOpenChange,
  item,
}: {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  item: User;
}) {
  return (
    <>
      <Modal
        isOpen={isOpen}
        onOpenChange={onOpenChange}
        portalContainer={document.getElementById("main")!}
        backdrop="blur"
        scrollBehavior="outside"
        size="3xl"
      >
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader>Просмотр пользователя</ModalHeader>
              <ModalBody>
                <div className="flex flex-col gap-1 mb-2">
                  <TableBuilder
                    displayOptions={false}
                    displaySearch={false}
                    removeWrapper
                    columns={[
                      {
                        label: "Имя пользователя",
                        key: "username",
                        type: ColumnType.String,
                      },
                      {
                        label: "Имя",
                        key: "first_name",
                        type: ColumnType.String,
                      },
                      {
                        label: "Фамилия",
                        key: "last_name",
                        type: ColumnType.String,
                      },
                      {
                        label: "Номер телефона",
                        key: "phone_number",
                        type: ColumnType.String,
                      },
                    ]}
                    data={[item]}
                  />
                </div>
              </ModalBody>
              <ModalFooter>
                <Button variant="flat" color="default" onClick={onClose}>
                  Закрыть
                </Button>
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
}
